import _ from 'lodash';
import { getCmsPageData } from '@/apis/apiCms';
import { ModuleInstance } from '@/apis/types/cms';
import JDISearch from '@/components/search';

interface Props {
  defaultKeyword: string;
  pageCode: string;
}

export const Search = async ({ defaultKeyword, pageCode }: Props) => {
  const pageData = await getCmsPageData(pageCode);
  const poolData = _.flattenDeep(pageData?.data?.floors?.map((f) => f?.moduleInstances))?.find(
    (m) => m.moduleCode === 'global-setting',
  ) as ModuleInstance;
  return <JDISearch defaultKeyword={defaultKeyword} poolData={poolData} pageCode={pageCode} />;
};
